<template>
  <div class="bgContent">
    <div class="header">保函网-保函验证查询系统</div>
    <div style="padding:100px">
        <el-descriptions :title="bhInfo.status==1?'此保函生效中':'此保函已失效'"  :column="1" border>
            <el-descriptions-item label="扫码查看">
                <el-image
                    style="width: 100px; height: 100px"
                    :src="bhInfo.bh_img"
                    :fit="fit"></el-image>
            </el-descriptions-item>
            <el-descriptions-item label="保函编号">{{bhInfo.bh_code}}</el-descriptions-item>
            <el-descriptions-item label="保函条码">{{bhInfo.bh_code_tm}}</el-descriptions-item>
            <el-descriptions-item label="受益人">{{bhInfo.bh_syr}}</el-descriptions-item>
            <el-descriptions-item label="申请单位">{{bhInfo.bh_sqdw}}</el-descriptions-item>
            <el-descriptions-item label="工程名称">{{bhInfo.bh_gcmc}}</el-descriptions-item>
            <el-descriptions-item label="担保金额">{{bhInfo.bh_money}}元</el-descriptions-item>
            <el-descriptions-item label="大写金额">{{bhInfo.bh_money_big}}</el-descriptions-item>
            <el-descriptions-item label="担保截至日">{{bhInfo.time_end}}</el-descriptions-item>
            <el-descriptions-item label="担保人">{{bhInfo.bh_dbgs}}</el-descriptions-item>
            
        </el-descriptions>
    </div>
    <div class="foot">保函网</div>
  </div>
</template>

<script>
import {searchBhApi,getBhInfoApi} from "@/api/http"
export default {
  data () {
    return {
        bhCode:'',
        bhInfo:{},
    }
  },
  mounted:function(){      
      if(!this.$route.query.bhCode){
          this.$router.push('./')
          return;
      }
      this.bhCode = this.$route.query.bhCode;
      var that = this;
      getBhInfoApi({bh_code:this.bhCode}).then(res=>{
        console.log(res)
        that.bhInfo = res;
      })
  },
  methods:{
    checkSearch:function(e){
      if(!this.bhtm){
        this.$message('请输入保函条码!');
        return;
      }
      if(!this.fwm){
        this.$message('请输入防伪码!');
        return;
      }
      this.showYzLoading = true;
      console.log(this.bhtm);
      let param = {
        bh_code_tm:this.bhtm,
        bh_code_fwm:this.fwm
      }
      var that = this;
      searchBhApi(param).then(res=>{
        console.log(res)
        that.showYzLoading = false;
        if(!res){
          that.$message.error('查询不到保函信息!');
          return;
        }
      })
    }
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.header{
  position: fixed;
right: 0;
top: 0;
left: 0;
height: 45px;
line-height: 45px;
background: #2c2e31;
color: white;
border-top: 1px solid #ddd;
text-align: center;
box-shadow: 0 0 4px 1px #dcdcdc;
z-index: 999;
}
.foot{
  position: fixed;
right: 0;
bottom: 0;
left: 0;
height: 45px;
line-height: 45px;
background: #ffffff;
border-top: 1px solid #ddd;
text-align: center;
box-shadow: 0 0 4px 1px #dcdcdc;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
html {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%
}

body {
    margin: 0;
    padding: 0;font-family:'Microsoft YaHei';
    
}

.bgContent{
    /* background: url("../assets/detailbh.jpg");
    background-repeat:no-repeat;
    background-position: center 0px;
        background-size: cover; */
}

ul,ol,li,dl,dt,dd,h1,h2,h3,h4,h5,h6,hgroup,p,blockquote,figure,form,fieldset,input,legend,pre,abbr,button {
    margin: 0;
    padding: 0
}

ul{ list-style: none;}

pre,code,address,caption,th,figcaption {
    font-size: 1em;
    font-weight: normal;
    font-style: normal
}

fieldset,iframe,img {
    border: 0
}

caption,th {
    text-align: left
}

table {
    border-collapse: collapse;
    border-spacing: 0
}

article,aside,footer,header,nav,main,section,summary,details,hgroup,figure,figcaption {
    display: block
}

audio,canvas,video,progress {
    display: inline-block;
    vertical-align: baseline
}

button {
    background: none;
    border: 0;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    color: inherit;
    cursor: pointer;
    font: inherit;
    line-height: inherit;
    overflow: visible;
    vertical-align: inherit
}

input,textarea,select,input:focus,button,button:focus {
    outline: none;
}

button:disabled {
    cursor: default
}

:focus {
    outline: 3px solid #c1e0fe;
    outline: 3px solid rgba(131,192,253,0.5);
    outline-offset: 1px
}

:focus[data-focus-method="mouse"]:not(input):not(textarea):not(select),:focus[data-focus-method="touch"]:not(input):not(textarea):not(select) {
    outline: none
}

::-moz-focus-inner {
    border: 0;
    padding: 0
}

/*color*/
.blue{ color:#0666e1 ;}
.orange{ color: #fc8800 ;}

.head{ height: 60px; background: #2c2e31;}
.head .centre{ width: 1100px; margin: 0 auto;}

.content{ width: 800px; margin: 0 auto; padding-top: 80px;}
.content .home-top{ padding: 0 100px; width: 600px;}
.system-title{ height: 150px; position: relative; padding-left: 200px;}

.magnifier-icon{ position: absolute; top: 0; left: 0;}
.system-title .title{ padding-top: 10px; line-height: 60px; font-weight: bold; color:#5c626b;; font-size: 40px;}
.system-title .explain{ color: #d89d58; font-size: 16px;}

.form-box .level-item{ position: relative; margin-top: 30px; min-height: 40px; padding-left: 100px;}
.form-box .level-item .key{ position: absolute; width: 100px; left: 0; top: 0; line-height: 40px; color: #666666;}
.form-box .input-text input{ padding: 0 10px; box-sizing: border-box; width: 100%; height: 40px; line-height: 40px; background: #f7f7f7; border: 1px solid #eeeeee; border-radius:6px;}
.form-box  .submit-box{ text-align: center;}
.form-box  .submit{ margin: 0 auto; width: 200px; height: 40px; border-radius: 6px; background: #ebcb30; color: #ffffff;}
.tip{ font-size: 14px; padding-top: 10px; color: #161716;}

.query-method{ padding-top: 40px; padding-bottom: 100px;}
.query-method .take-care{ line-height: 22px; color:#101010;}
.query-method .take-care .title{ font-weight: bold; color: #333;}
.query-method .take-care p{ padding: 5px 0; text-indent: -10em; padding-left: 10em;}
.method-box{ padding:20px 30px 30px; background: #b7b8b9;; border: 1px solid #7d8288;border-radius: 6px;}
.method-box .hd{ height: 40px; line-height: 40px; font-size: 16px; font-weight: bold; color: #333;}
.method-box li{ line-height: 30px; color:#1f1e1e;}

.detail{ width: 1100px; margin: 0 auto;}
.detail .code-list{ padding-bottom: 20px; padding-top: 45px; line-height: 40px; border-bottom: 1px solid #DCDCDC;}
.detail .code-list ul::after{ content:'';display: table; clear: both;}
.detail .code-list li{ float: left; padding-right: 30px;}
.detail .continue{float: right; width: 120px; height: 40px; border-radius: 6px; background: #0666e1; color: #ffffff;}
.detail .jsondata{padding:0 40px;}
.detail .jsondata li{ position: relative; padding: 10px 0 10px 160px; line-height: 30px; min-height: 30px;}
.detail .jsondata li .key{ position: absolute; left: 0; top: 0; padding: 10px 0; display: inline-block; width: 150px; text-align: right; color: #999;}
.detail .jsondata li .val{min-height: 30px;}
.detail  .remark{padding: 40px;}


.foot{ position: fixed; right: 0; bottom: 0; left: 0; height: 45px; line-height: 45px; background: #ffffff;border-top: 1px solid #ddd; text-align: center; box-shadow: 0 0 4px 1px #dcdcdc;}


</style>



// WEBPACK FOOTER //
// src/components/Detail.vue